import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "image", "download", "raw"]

  connect() {
    this.updateTotalImages()
    this.setupMutationObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupMutationObserver() {
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          this.updateTotalImages()
        }
      })
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  updateTotalImages() {
    this.totalImages = this.element.querySelectorAll(".show-item").length
  }

  open(event) {
    event.preventDefault()
    const container = event.currentTarget
    if (event.target.closest(".download-button")) return // Ignore clicks on download button

    this.currentIndex = parseInt(container.dataset.modalIndex, 10)
    this.updateImage(container)
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  backgroundClick(event) {
    if (!this.contentTarget.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "ArrowLeft") {
      this.previousImage()
    } else if (event.key === "ArrowRight") {
      this.nextImage()
    } else if (event.key === "Escape") {
      this.close()
    }
  }

  previousImage() {
    this.currentIndex = (this.currentIndex - 1 + this.totalImages) % this.totalImages
    const prevButton = this.getButtonByIndex(this.currentIndex)
    if (prevButton) {
      this.updateImage(prevButton)
    }
  }

  nextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.totalImages
    const nextButton = this.getButtonByIndex(this.currentIndex)
    if (nextButton) {
      this.updateImage(nextButton)
    }
  }

  updateImage(container) {
    const img = container.querySelector("img")
    this.imageTarget.src = img.src
    this.downloadTarget.href = container.dataset.modalDownloadUrl
    this.rawTarget.href = container.dataset.modalRawUrl
    this.totalImages = parseInt(container.dataset.modalTotalImages, 10)
  }

  getButtonByIndex(index) {
    return this.element.querySelector(`[data-modal-index="${index}"]`)
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  preventModalOpen(event) {
    event.preventDefault()
    event.stopPropagation()
    window.location.href = event.currentTarget.href
  }
} 